import rest from '../rest'

export const getUserInformations = () =>{
    return async (dispatch) => {
        await rest.get('/user/informations.json')
        .then((response) => {
            dispatch({type: 'GET_USER_LOGGED', payload: response.data})
        }) 
    }
}